import { OrderShippingProvider } from '../../types/order'
import { Box } from '@mui/material'
import { ImageLinks, LogoTypeProvider } from '../../constants/image-link'
import React from 'react'

interface Props {
  trackingProvider: OrderShippingProvider
}

const TrackingProviderImage = (props: Props) => {
  const { trackingProvider } = props
  return (
    <Box className={'shipment-logo'} justifyContent={'center'} display={'flex'} mb={1}>
        <img src={ImageLinks[`LOGO_${trackingProvider.toUpperCase()}` as LogoTypeProvider]} />
    </Box>
  )
}

export default TrackingProviderImage
